export const tanstackRouterBuiltInAPI = [
  "createHistory",
  "createBrowserHistory",
  "createHashHistory",
  "createMemoryHistory",
  "BlockerFn",
  "HistoryLocation",
  "RouterHistory",
  "ParsedPath",
  "HistoryState",
  "invariant",
  "warning",
  "useAwaited",
  "Await",
  "ScriptOnce",
  "defer",
  "CatchBoundary",
  "ErrorComponent",
  "FileRoute",
  "createFileRoute",
  "FileRouteLoader",
  "LazyRoute",
  "createLazyRoute",
  "createLazyFileRoute",
  "FileRoutesByPath",
  "FileRouteTypes",
  "LazyRouteOptions",
  "lazyRouteComponent",
  "useLinkProps",
  "createLink",
  "Link",
  "linkOptions",
  "Matches",
  "useMatchRoute",
  "MatchRoute",
  "useMatches",
  "useParentMatches",
  "useChildMatches",
  "isMatch",
  "matchContext",
  "Match",
  "Outlet",
  "isServerSideError",
  "defaultDeserializeError",
  "useMatch",
  "useLoaderDeps",
  "useLoaderData",
  "joinPaths",
  "cleanPath",
  "trimPathLeft",
  "trimPathRight",
  "trimPath",
  "resolvePath",
  "parsePathname",
  "interpolatePath",
  "matchPathname",
  "removeBasepath",
  "matchByPath",
  "encode",
  "decode",
  "redirect",
  "isRedirect",
  "rootRouteId",
  "RouteApi",
  "getRouteApi",
  "Route",
  "createRoute",
  "RootRoute",
  "rootRouteWithContext",
  "createRootRoute",
  "createRootRouteWithContext",
  "createRouteMask",
  "NotFoundRoute",
  "componentTypes",
  "createRouter",
  "Router",
  "lazyFn",
  "SearchParamError",
  "PathParamError",
  "getInitialRouterState",
  "defaultSerializeError",
  "useScrollRestoration",
  "useElementScrollRestoration",
  "ScrollRestoration",
  "defaultParseSearch",
  "defaultStringifySearch",
  "parseSearchWith",
  "stringifySearchWith",
  "defaultTransformer",
  "useBlocker",
  "Block",
  "useNavigate",
  "Navigate",
  "useParams",
  "useSearch",
  "getRouterContext",
  "useRouteContext",
  "useRouter",
  "useRouterState",
  "useLocation",
  "escapeJSON", // "SSR"
  "useLayoutEffect", // "SSR"
  "pick",
  "functionalUpdate",
  "replaceEqualDeep",
  "isPlainObject",
  "isPlainArray",
  "deepEqual",
  "useStableCallback",
  "shallow",
  "notFound",
  "isNotFound",
  "CatchNotFound",
  "DefaultGlobalNotFound",
  "createControlledPromise",
  "retainSearchParams",
  "stripSearchParams"
]
